import { CalendarRangeOutput } from "../models";
import { formatCustomDate } from "./format-custom-date.util";

export const getFormattedDateRange = (calendarType: CalendarRangeOutput, lang: string): string => {
  const translations = {
    es: {
      currentYear: 'Año Actual:',
      previousYear: 'Año Anterior:',
      unknownFormat: 'Formato desconocido'
    },
    en: {
      currentYear: 'Current Year:',
      previousYear: 'Previous Year:',
      unknownFormat: 'Unknown format'
    }
  };

  const t = translations[lang as keyof typeof translations] || translations.es;

  switch (calendarType.tipo) {
    case 'RANGO_DIAS':
      return `${formatCustomDate(calendarType.fechaInicio ?? '', lang)} / ${formatCustomDate(calendarType.fechaFin ?? '', lang)}`;
    case 'RANGO_MESES':
      return `${formatCustomDate(calendarType.fechaInicio ?? '', lang)} / ${formatCustomDate(calendarType.fechaFin ?? '', lang)}`;
    case 'MES_ACTUAL':
    case 'MES_ANTERIOR':
      return formatCustomDate(calendarType.date ?? '', lang);
    case 'ANIO_ACTUAL':
      return `${t.currentYear} ${calendarType.date}`;
    case 'ANIO_ANTERIOR':
      return `${t.previousYear} ${calendarType.date}`;
    case 'SEMANA_ANTERIOR':
      return `${formatCustomDate(calendarType.fechaInicio ?? '', lang)} / ${formatCustomDate(calendarType.fechaFin ?? '', lang)}`;
    case 'DIA_ANTERIOR':
    case 'DIA_ESPECIFICO':
      return formatCustomDate(calendarType.date ?? '', lang);
      default:
      return t.unknownFormat;
  }
}
